import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BadgeModule } from '@commons/badge/badge.module';
import { ModalModule } from '@commons/modal/modal.module';
import { PopupModule } from '@commons/popup/popup.module';
import { CityFilterComponent } from '@commons/search-engine/city-filter/city-filter.component';
import { ContractFacetFilterComponent } from '@commons/search-engine/contract-facet-filter/contract-facet-filter.component';
import { DomainFacetFilterComponent } from '@commons/search-engine/domain-facet-filter/domain-facet-filter.component';
import { DomainCategoryPipe } from '@commons/search-engine/domain-facet-filter/pipes/domain-category.pipe';
import { DropdownComponent } from '@commons/search-engine/dropdown/dropdown.component';
import { FacetListComponent } from '@commons/search-engine/facet-list/facet-list.component';
import { FieldFacetFilterComponent } from '@commons/search-engine/field-facet-filter/field-facet-filter.component';
import { KeywordInputComponent } from '@commons/search-engine/keyword-input/keyword-input.component';
import { SearchEngineComponent } from '@commons/search-engine/search-engine/search-engine.component';
import { SvgIconModule } from '@commons/svg-icon/svg-icon.module';
import { TrackerModule } from '@commons/tracker/tracker.module';
import { I18nFieldModule } from '@domains/company/i18n-field/i18n-field.module';
import { I18nDomainCategoryModule } from '@domains/job/i18n-domain-category/i18n-domain-category.module';
import { I18nDomainModule } from '@domains/job/i18n-domain/i18n-domain.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SvgIconModule,
    PopupModule,
    NgSelectModule,
    BadgeModule,
    PerfectScrollbarModule,
    I18nFieldModule,
    I18nDomainModule,
    I18nDomainCategoryModule,
    ModalModule,
    TrackerModule,
  ],
  declarations: [
    SearchEngineComponent,
    DropdownComponent,
    KeywordInputComponent,
    CityFilterComponent,
    ContractFacetFilterComponent,
    DomainFacetFilterComponent,
    FacetListComponent,
    DomainCategoryPipe,
    FieldFacetFilterComponent,
  ],
  exports: [
    FormsModule,
    SearchEngineComponent,
    DropdownComponent,
    CityFilterComponent,
    ContractFacetFilterComponent,
    DomainFacetFilterComponent,
    FieldFacetFilterComponent,
  ],
})
export class SearchEngineModule {}
